export function registerAssetDriftHandler(): void {
  up.script.config.assetSelectors = ['[up-watch-asset]']

  up.on('up:assets:changed', function (event) {
    const { renderOptions, response } = event
    const method = (renderOptions.method ?? 'GET').toUpperCase()
    // Non-GET requests and non-root layers are allowed through: doing a full reload
    // would lose form data or close overlays, so we accept stale assets in those cases.
    if (method !== 'GET') return

    // Don't do this for renders from strings.
    if (!response) return

    // Don't do this for errors, since the error page might have different
    // assets too. Mostly relevant for admin area.
    if (response?.status === 500) return

    const targetLayer = up.layer.get(renderOptions.layer ?? 'current')
    if (!targetLayer?.isRoot()) return

    event.preventDefault()
    up.network.loadPage({ url: renderOptions.url, method })
  })
}
